export enum ServiceOfferingProcessingTypes {
    DURING_VERIFY = "DURING_VERIFY",
    REDIRECT = "REDIRECT",
    POST_VERIFY = "POST_VERIFY",
    PENULTIMATE_VERIFY = "PENULTIMATE_VERIFY",
    FINAL_VERIFY = "FINAL_VERIFY",
    ASYNCHRONOUS = "ASYNCHRONOUS"
}